export const TOKENALL = {
  TOKEN_WIT: '3EX4VKAHIZI64W5XLHB6Y7EKR5GC5KUX',
  TOKEN_LUIS: '36fe2c5ac7bf456fbc30bb13f13a710a',
};
